<tt-page *ngIf="!!edit">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-tabs [(ttSelectedId)]="selectedBgBatchDelivery">
                <tt-tab ttId="0" ttLabel="batchdelivery_gb_simple"></tt-tab>
                <tt-tab ttId="1" ttLabel="batchdelivery_gb_details"></tt-tab>
                <tt-tab ttId="2" ttLabel="batchdelivery_gb_tracing"></tt-tab>
            </tt-tabs>

            <div [hidden]="selectedBgBatchDelivery !== '0'">
                <ng-container *ngTemplateOutlet="info"></ng-container>
            </div>

            <div [hidden]="selectedBgBatchDelivery !== '1'">
                <ng-container *ngTemplateOutlet="economics"></ng-container>
            </div>

            <div [hidden]="selectedBgBatchDelivery !== '2'">
                <ng-container *ngTemplateOutlet="tracing"></ng-container>
            </div>

            <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="batchdelivery_gb_simple">
                <ng-container *ngTemplateOutlet="info"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="batchdelivery_gb_details">
                <ng-container *ngTemplateOutlet="economics"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="batchdelivery_gb_tracing">
                <ng-container *ngTemplateOutlet="tracing"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-3 p-5" ttHeading="h_functions">
                <ng-container *ngTemplateOutlet="buttons"></ng-container>
            </tt-card>
        </div>

        <tt-card class="col-xs-12 col-md-9 p-5">
            <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        </tt-card>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!edit">
        <tt-input-number ttLabel="stockbatch_keyno" [ttModel]="edit.stockbatch_keyno" ttTextAlign="right" ttFormatNumber ttDecimals ttReadonly></tt-input-number>
        <tt-input ttLabel="stockplace_name" [ttModel]="edit.stockplace_name" ttReadonly></tt-input>
        <tt-input ttLabel="stocklocation_name" [ttModel]="edit.stocklocation_name" [ttButtons]="stockLocationNameButtons" ttReadonly></tt-input>
        <tt-input ttLabel="prod_id" [ttModel]="edit.prod_id" [ttButtons]="productButtons" ttReadonly></tt-input>
        <tt-textarea ttLabel="prod_name_long" [ttModel]="edit.prod_name_long" ttReadonly></tt-textarea>
        <tt-input ttLabel="suppliers_batchno" [(ttModel)]="edit.suppliers_batchno"></tt-input>
        <tt-input ttLabel="best_before_date" [ttModel]="edit.best_before_date" ttReadonly></tt-input>
        <tt-checkbox ttLabel="change_best_before_date" [(ttModel)]="edit.change_best_before_date"></tt-checkbox>
        <tt-date [hidden]="edit.change_best_before_date !== '1'" ttLabel="new_best_before_date" [(ttModel)]="edit.new_best_before_date"></tt-date>
        <tt-input-number ttLabel="quantity" [ttModel]="edit.quantity" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input-number ttLabel="quantity_stock" [ttModel]="edit.quantity_stock" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input-number ttLabel="quantity_reserved" [ttModel]="edit.quantity_reserved" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input ttLabel="allocation_info" [ttModel]="edit.allocation_info" [ttButtons]="allocationInfoButtons" ttReadonly></tt-input>
        <tt-datetime ttLabel="stock_datetime" [ttModel]="edit.stock_datetime" ttReadonly></tt-datetime>
    </ng-container>
</ng-template>

<ng-template #economics>
    <ng-container *ngIf="!!edit">
        <tt-textarea ttLabel="description" [ttModel]="edit.description" ttReadonly></tt-textarea>
        <tt-input-number ttLabel="stockbatch_cost_locval" [ttModel]="edit.price_locval" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input-number ttLabel="purchprice_locval" [ttModel]="edit.purchprice_locval" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input-number *ngIf="edit.purchprice_invval !== '0.00'" ttLabel="purchprice_invval" [ttSublabel]="edit.valuta_id" [ttModel]="edit.purchprice_invval" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input-number ttLabel="exchangerate" [ttModel]="edit.exchangerate" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input-number ttLabel="opcost_var_var" [ttModel]="edit.opcost_var_var" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input-number ttLabel="freight_eu" [ttModel]="edit.freight_eu" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input-number ttLabel="freight_ex_eu" [ttModel]="edit.freight_ex_eu" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input-number ttLabel="customs_eu" [ttModel]="edit.customs_eu" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input-number ttLabel="customs_ex_eu" [ttModel]="edit.customs_ex_eu" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input-number ttLabel="divcost" [ttModel]="edit.divcost" ttTextAlign="right" ttFormatNumber ttDecimals="2" ttReadonly></tt-input-number>
        <tt-input ttLabel="country_id_origin" [ttModel]="edit.country_id_origin" ttReadonly></tt-input>
    </ng-container>
</ng-template>

<ng-template #tracing>
    <ng-container *ngIf="!!edit">
        <tt-datetime ttLabel="reg_datetime" [ttModel]="edit.reg_datetime" ttReadonly></tt-datetime>
        <tt-input ttLabel="origin_name" [ttModel]="edit.origin_name" ttReadonly></tt-input>
        <tt-input-number *ngIf="edit.purch_order_no !== '0'" ttLabel="purch_order_no" [ttModel]="edit.purch_order_no" ttTextAlign="right" ttFormatNumber ttDecimals [ttButtons]="purchaseOrderButtons" ttReadonly></tt-input-number>
        <tt-input-number *ngIf="edit.batchdelivery_keyno !== '0'" ttLabel="batchdelivery_keyno" [ttModel]="edit.batchdelivery_keyno" ttTextAlign="right" ttFormatNumber ttDecimals [ttButtons]="batchDeliveryButtons" ttReadonly></tt-input-number>
        <tt-input-number *ngIf="edit.po_keyno !== '0'" ttLabel="po_keyno" [ttModel]="edit.po_keyno" ttTextAlign="right" ttFormatNumber ttDecimals ttReadonly></tt-input-number>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!edit">
        <tt-button ttText="print_barcode_label" (ttClick)="goToFunc('printdialogue')" ttIcon="fa fa-solid fa-print"></tt-button>
        <tt-button *ngIf="edit.setting_select_report === '1'" ttText="select_report_and_print" (ttClick)="goToFunc('selectreport')" ttIcon="fa fa-solid fa-print"></tt-button>
        <tt-button-goto [ttText]="'stockbatchget_gotostock'" [ttGoto]="'stockget'" [ttGotoParms]="{ stock_keyno: edit.stock_keyno }"></tt-button-goto>
        <tt-button-goto [ttText]="'stockbatchget_trace'" [ttGoto]="'tracesb'" [ttGotoParms]="{ stockbatch_keyno: edit.stockbatch_keyno }"></tt-button-goto>
        <tt-button-goto *ngIf="edit.show_button_pofinishprodworks === '1'" [ttText]="'show_pofinishprodworks'" [ttGoto]="'pofinishprodworks'" [ttGotoParms]="{ p2_pofinishprod_keyno: edit.p2_pofinishprod_keyno }"></tt-button-goto>
        <tt-button-goto [ttText]="'stockbatchget_checklistdatas'" [ttBadge]="edit.nbr_of_forms" [ttGoto]="'checklistdatas'" [ttGotoParms]="{ argtype: 'stockbatch_keyno', argvalue: edit.stockbatch_keyno }"></tt-button-goto>
        <tt-button-goto [ttText]="'stockbatchget_corr_qty'" [ttGoto]="'stockbatchcorrqty'" [ttGotoParms]="{ stockbatch_keyno: edit.stockbatch_keyno }"></tt-button-goto>
        <tt-button-goto [ttText]="'stockbatchget_stockcorrections'" [ttBadge]="edit.nbr_of_stockcorrections" [ttGoto]="'stockcorrections'" [ttGotoParms]="{ argtype: 'stockbatch_keyno', argvalue: edit.stockbatch_keyno }"></tt-button-goto>
        <tt-button-goto [ttText]="'stockbatchget_documents'" [ttBadge]="edit.nbr_of_documents" [ttGoto]="'documents'" [ttGotoParms]="{ argtype: 'stockbatch_keyno', argvalue: edit.stockbatch_keyno }"></tt-button-goto>
        <tt-button-goto [ttText]="'stockbatchget_pictures'" [ttBadge]="edit.nbr_of_pictures" [ttGoto]="'pictures'" [ttGotoParms]="{ argtype: 'stockbatch_keyno', argvalue: edit.stockbatch_keyno }"></tt-button-goto>
        <tt-button-settings></tt-button-settings>
    </ng-container>
</ng-template>
